import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'

const imageUrl = (url, placeholderUrl) => {
  if (url) return `url(${url})`
  if (placeholderUrl) return `url(${placeholderUrl})`
  return null
}

const Image = React.forwardRef((props, ref) => {
  const {
    backgroundPosition,
    backgroundRepeat,
    backgroundSize,
    borderRadius,
    boxProps,
    children,
    circle,
    className,
    forwardProps,
    height,
    placeholderUrl,
    style,
    url,
    width,
  } = props

  return (
    <Box
      alignItems="center"
      backgroundImage={imageUrl(url, placeholderUrl)}
      backgroundPosition={backgroundPosition || 'center center'}
      backgroundRepeat={backgroundRepeat || 'no-repeat'}
      backgroundSize={backgroundSize || 'cover'}
      borderRadius={circle ? width : borderRadius}
      className={className}
      flexShrink="0"
      height={circle ? width : height}
      justifyContent="center"
      ref={ref}
      style={style}
      width={width}
      {...boxProps}
      {...forwardProps}
    >
      {children}
    </Box>
  )
})

Image.propTypes = {
  backgroundPosition: PropTypes.string,
  backgroundRepeat: PropTypes.string,
  backgroundSize: PropTypes.string,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  boxProps: PropTypes.object,
  children: PropTypes.node,
  circle: PropTypes.bool,
  className: PropTypes.string,
  forwardProps: PropTypes.object,
  height: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.string]),
  placeholderUrl: PropTypes.string,
  style: PropTypes.object,
  url: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.array, PropTypes.number, PropTypes.string]),
}

export default Image
